<template>
  <el-container>
    <el-header>
      <HeaderCom></HeaderCom>
    </el-header>
    <el-main>
      <transition
        appear
        appear-to-class="animate__animated animate__bounceInDown "
      >
        <el-row>
          <el-col
            :span="24"
            style="display: flex;justify-content: center;margin-bottom: 12px"
          >
            <img src="./../../assets/image/schoolicon.png" alt="" height="72" />
          </el-col>
          <el-col :span="24">
            <div class="name-wrap">
              <h3>
                电商选品虚拟仿真实验
              </h3>
              <h6>
                Virtual simulation experiment of tea industry e-commerce
                selection for Southeast Asia
              </h6>
            </div>
          </el-col>
        </el-row>
      </transition>
      <el-row type="flex" justify="center">
        <el-row
          :gutter="32"
          type="flex"
          justify="center"
          style="max-width: 1600px;width: 100%"
        >
          <transition
            appear-to-class="animate__animated animate__fadeInLeft"
            appear
          >
            <el-col :span="18">
              <el-row :gutter="28" type="flex">
                <el-col :span="student.type === 1 ? 6 : 8">
                  <div class="nav-item" @click="show = true">
                    <div class="icon">
                      <img
                        :src="
                          require(`./../../assets/image/home/nav-icon-4.png`)
                        "
                        alt=""
                      />
                    </div>
                    <div class="label">
                      <h3>
                        引导
                      </h3>
                      <p>
                        guidance
                      </p>
                    </div>
                  </div>
                </el-col>
                <el-col :span="student.type === 1 ? 6 : 8">
                  <div class="nav-item " id="studyroom" @click="learn">
                    <div class="icon">
                      <img
                        :src="
                          require(`./../../assets/image/home/nav-icon-4.png`)
                        "
                        alt=""
                      />
                    </div>
                    <div class="label">
                      <h3>
                        学习室
                      </h3>
                      <p>
                        study room
                      </p>
                    </div>
                  </div>
                </el-col>
                <el-col :span="student.type === 1 ? 6 : 8">
                  <div class="nav-item" @click="start()" id="start">
                    <div class="icon">
                      <img
                        :src="
                          require(`./../../assets/image/home/nav-icon-1.png`)
                        "
                        alt=""
                      />
                    </div>
                    <div class="label">
                      <h3>
                        开始实验
                      </h3>
                      <p>
                        start the experiment
                      </p>
                    </div>
                  </div>
                </el-col>
                <el-col
                  :span="student.type === 1 ? 6 : 8"
                  v-if="student.type === 1"
                >
                  <router-link :to="{ path: '/systemmanager/system' }">
                    <div class="nav-item">
                      <div class="icon">
                        <img
                          :src="
                            require(`./../../assets/image/home/nav-icon-2.png`)
                          "
                          alt=""
                        />
                      </div>
                      <div class="label">
                        <h3>
                          系统管理
                        </h3>
                        <p>
                          system management
                        </p>
                      </div>
                    </div>
                  </router-link>
                </el-col>
                <el-col :span="student.type === 1 ? 6 : 8">
                  <router-link :to="{ path: '/systemmanager/historical' }">
                    <div class="nav-item">
                      <div class="icon">
                        <img
                          :src="
                            require(`./../../assets/image/home/nav-icon-3.png`)
                          "
                          alt=""
                        />
                      </div>
                      <div class="label">
                        <h3>
                          历史实验
                        </h3>
                        <p>
                          historical experiment
                        </p>
                      </div>
                    </div>
                  </router-link>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="history">
                    <div class="title">
                      <h3>
                        未完成的实验
                      </h3>
                      <p>
                        An unfinished experiment
                      </p>
                    </div>
                    <div class="content">
                      <div class="item-wrap" v-if="formatterRecord.length > 0">
                        <div
                          class="item"
                          v-for="(item, index) in formatterRecord.slice(0, 3)"
                          :key="index"
                        >
                          <div class="cell">
                            <img
                              src="./../../assets/image/home/history-time.png"
                              alt=""
                            />
                            <span class="txt">
                              {{
                                new Date(item.createTime).$Format(
                                  "yyyy/MM/dd hh:mm"
                                )
                              }}
                            </span>
                          </div>
                          <div class="cell">
                            <img
                              src="./../../assets/image/home/history-status.png"
                              alt=""
                            />
                            <span class="txt" v-if="item.status === 1">
                              实验中
                            </span>
                            <span class="txt" v-if="item.status === 2">
                              待评价
                            </span>
                            <span class="txt" v-if="item.status === 3">
                              已评价
                            </span>
                            <span class="txt" v-if="item.status === 4">
                              已取消
                            </span>
                          </div>
                          <div class="cell right"></div>
                          <div class="cell">
                            <button
                              @click.prevent="
                                $router.push({
                                  path: '/data/source',
                                  query: { id: item.id },
                                })
                              "
                            >
                              继续实验
                            </button>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <el-empty description="暂无历史实验"></el-empty>
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </el-col>
          </transition>
          <transition
            appear-to-class="animate__animated animate__fadeInRight"
            appear
          >
            <el-col :span="6">
              <div class="user-wrap">
                <div class="title">
                  <h3>
                    基本信息
                  </h3>
                  <p>
                    essential information
                  </p>
                </div>
                <div class="content">
                  <div class="item">
                    <div class="icon">
                      <img
                        src="./../../assets/image/home/user-user.png"
                        alt=""
                      />
                    </div>
                    <div class="txt">
                      <p>
                        姓名
                      </p>
                      <p>
                        {{ student.realName }}
                      </p>
                    </div>
                  </div>
                  <div class="item">
                    <div class="icon">
                      <img src="./../../assets/image/home/user-no.png" alt="" />
                    </div>
                    <div class="txt">
                      <p>
                        学号
                      </p>
                      <p>
                        {{ student.studentNo }}
                      </p>
                    </div>
                  </div>
                  <div class="item">
                    <div class="icon">
                      <img
                        src="./../../assets/image/home/user-school.png"
                        alt=""
                      />
                    </div>
                    <div class="txt">
                      <p>
                        学校
                      </p>
                      <p>
                        {{ student.schoolName }}
                      </p>
                    </div>
                  </div>
                  <div class="item">
                    <div class="icon">
                      <img
                        src="./../../assets/image/home/user-class.png"
                        alt=""
                      />
                    </div>
                    <div class="txt">
                      <p>
                        班级
                      </p>
                      <p>
                        {{ student.className }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </transition>
        </el-row>
      </el-row>
    </el-main>
    <el-dialog
      append-to-body
      class="custom-modal"
      title=""
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :visible.sync="show"
      :lock-scroll="true"
      @open="isBlur(true)"
      @close="isBlur(false)"
      fullscreen
    >
      <div class="content">
        <div class="content-title">
          <img
            src="./../../assets/image/simulation/tea3.png"
            alt=""
            height="40"
          />
        </div>
        <div class="content-main">
          <el-carousel
            ref="carousel_1"
            height="100vh"
            direction="vertical"
            :autoplay="false"
            trigger="click"
          >
            <el-carousel-item>
              <div class="carousel-wrap carousel-1-1">
                <div class="carousel-view" v-if="carouselIndex === -6">
                  <transition
                    appear
                    appear-to-class="animate__animated animate__fadeInUp animate__delay-500ms"
                  >
                    <p>
                      2022年10月16日，中国共产党第二十次全国代表大会在北京召开，党的二十大报告中提及，要全面推进乡村振兴。发展乡村特色产业，拓宽农民增收致富渠道。巩固拓展脱贫攻坚成果，增强脱贫地区和脱贫群众内生发展动力。以茶助富农、以茶促振兴，茶产业作为民生产业，在乡村振兴，茶农增收致富的道路上，始终承担着重要角色。
                    </p>
                  </transition>
                  <transition
                    appear
                    appear-to-class="animate__animated animate__fadeInUp animate__delay-1s"
                  >
                    <p>
                      “三农问题”、乡村振兴等话题引起了社会各界的广泛关注和热议。来自全国各地的数千名代表们心系人民，积极传达群众呼声，其中有几位代表就茶产业发展问题建言献策，让我们一起来了解一下吧！
                    </p>
                  </transition>
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="carousel-wrap carousel-1-2">
                <div class="carousel-view" v-if="carouselIndex === -5">
                  <transition
                    appear
                    appear-to-class="animate__animated animate__fadeInUp animate__delay-500ms"
                  >
                    <p>
                      【祝雪兰：总书记嘱托把六堡茶做大做强】
                      祝雪兰是六堡茶制作技艺自治区级代表性传承人，苍梧县六堡镇山坪村党支部书记、村民委主任。为改变山坪村茶叶种植分散、经营规模小、茶叶质量参差不齐的问题，她将自家祖传的制茶工艺无偿教给民众，带领乡亲们探索“党支部+合作社+农户”模式，抱团发展茶产业。如今，山坪村茶园扩种到2600多亩，全村人均收入超过两万元，村集体经济达13.8万元。
                    </p>
                  </transition>
                  <transition
                    appear
                    appear-to-class="animate__animated animate__fadeInUp animate__delay-1s"
                  >
                    <p>
                      “茶产业大有前途。下一步，要打出自己的品牌，把茶产业做大做强。”面对总书记的殷殷叮嘱，祝雪兰信心满满地说，我一定不辜负总书记的期望，竭尽所能带领乡亲不断发展壮大六堡茶产业，把这片小叶子做成乡村振兴大产业，让广大群众过上更加幸福美好的生活。
                    </p>
                  </transition>
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="carousel-wrap carousel-1-3">
                <div class="carousel-view" v-if="carouselIndex === -4">
                  <transition
                    appear
                    appear-to-class="animate__animated animate__fadeInUp animate__delay-500ms"
                  >
                    <p>
                      【余静：积极发展生态茶业】
                      余静，金寨县花石乡大湾村党总支第一书记、驻村工作队队长，他积极发展大湾村生态茶业，采取“公司+农户+基地”模式，带动村民种茶增收。目前村里已有茶园5000余亩，“六安瓜片”等知名茶叶享誉全国，农户务工、企业营销的产业链成型稳定。
                    </p>
                  </transition>
                  <transition
                    appear
                    appear-to-class="animate__animated animate__fadeInUp animate__delay-1s"
                  >
                    <p>
                      目前，大湾村正在朱湾组新建一座特色产业发展中心，集加工体验、展销与直播等功能于一体，届时大湾村的农产品将在这里走向全国各地。
                    </p>
                  </transition>
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="carousel-wrap carousel-1-4">
                <div class="carousel-view" v-if="carouselIndex === -3">
                  <transition
                    appear
                    appear-to-class="animate__animated animate__fadeInUp animate__delay-500ms"
                  >
                    <p>
                      【龙守菊：“抱团发展”走出共富路】
                      龙守菊是安徽省黄山市黄山区乌石镇乌石村党总支委员、黄山徽黔种养专业合作社理事长，2018年，她成立了黄山徽黔种养专业合作社。后来，她参加创业扶贫大赛并一举获奖，并将奖金用于置办茶叶生产机械以及合作社的建设。如今，合作社已有25户村民加入，其中少数民族家庭占70%以上，年销售额达到百万元。
                    </p>
                  </transition>
                  <transition
                    appear
                    appear-to-class="animate__animated animate__fadeInUp animate__delay-1s"
                  >
                    <p>
                      接下来，龙守菊将继续扩大合作社茶叶加工基地，发挥好桥梁纽带的作用，让徽黔种养专业合作社成为乡村振兴大舞台，带动更多的乡亲们在乡村振兴的道路上一起共筑幸福梦。
                    </p>
                  </transition>
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="carousel-wrap carousel-1-5">
                <div class="carousel-view" v-if="carouselIndex === -2">
                  <transition
                    appear
                    appear-to-class="animate__animated animate__fadeInUp animate__delay-500ms"
                  >
                    <p>
                      【华锦先：“三产融合”促发展】
                      华锦先，现任福建省龙岩市新罗区小池镇培斜村党支部书记，他带领培斜村发展竹茶产业，
                      走出了一条以“竹茶加工、乡村旅游、农村电商”三大特色产业为中心的三产融合发展之路。
                    </p>
                  </transition>
                  <transition
                    appear
                    appear-to-class="animate__animated animate__fadeInUp animate__delay-1s"
                  >
                    <p>
                      对于未来发展，这位培斜村带头人的心里早已绘就了蓝图：推进竹茶加工、农村电商、乡村旅游“三产融合”发展体系更加完备;对村内资源进行梳理整合，实现景区整体规范化运营，深入打造生态游、体验游、康养游等旅游线路;谋划民宿规模村建设，积极推进全村旅游产业高质量发展，打造集“吃住行游购娱”为一体的知名景区。
                    </p>
                  </transition>
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="carousel-wrap carousel-1-6">
                <div class="carousel-view" v-if="carouselIndex === -1">
                  <transition
                    appear
                    appear-to-class="animate__animated animate__fadeInUp animate__delay-500ms"
                  >
                    <p>
                      【温文溪：改良技术，传授制茶经验】
                      温文溪是安溪铁观音制茶工艺大师，退伍后，他不断琢磨技术改良，解决了制茶过程中的一系列难题。2016年，他成立安溪铁观音制作技艺传习所，频繁深入田间地头传授制茶经验。多年来，先后开展讲座800多场次，惠及茶农2万多人次。
                    </p>
                  </transition>
                  <transition
                    appear
                    appear-to-class="animate__animated animate__fadeInUp animate__delay-1s"
                  >
                    <p>
                      温文溪说，我将继续坚守在农村发展的第一线，开拓创新，通过解决一个个实际问题，提高茶叶制作效率，提高茶叶质量，让更多的人种好茶、制好茶、喝好茶，以茶产业带动就业、创业、增收、致富，为推动乡村全面振兴贡献力量。
                    </p>
                  </transition>
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="carousel-wrap carousel-1">
                <div class="carousel-view" v-if="carouselIndex === 0">
                  <transition
                    appear
                    appear-to-class="animate__animated animate__fadeInUp animate__delay-500ms"
                  >
                    <p>
                      茶产业是福建地理标志性产品，茶文化体系深刻地影响东南亚东北亚地区的消费。
                    </p>
                  </transition>
                  <transition
                    appear
                    appear-to-class="animate__animated animate__fadeInUp animate__delay-1s"
                  >
                    <p>
                      将茶文化、茶产业、茶科技等通过跨境电商销售模式，强化福建与东南亚国家的贸易合作；助推RCEP自由贸易协定，推动“一带一路”高质量发展。
                      以二十大“全面推进乡村振兴”，加快构建发展新格局，着力推动高质量发展，以福建特色产业茶叶为介质，打造品牌出海，推进福建产品国际化发展。提升产教融合的落地性、可操作性，树立开放的国际化意识。
                    </p>
                    <p></p>
                  </transition>
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="carousel-wrap carousel-2">
                <div class="carousel-view" v-if="carouselIndex === 1">
                  <transition
                    appear
                    appear-to-class="animate__animated animate__fadeInUp animate__delay-500ms"
                  >
                    <p>
                      海上丝绸之路，是古代中国与外国交通贸易和文化交往的海上通道，其带动不同文化的交流碰撞，推动了世界的进步和发展，“友善、包容、互惠、共生、坚韧”的海上丝绸之路的文化内涵对于中国与世界更深层次的互动具有极其重要的意义。
                    </p>
                  </transition>
                  <transition
                    appear
                    appear-to-class="animate__animated animate__fadeInUp animate__delay-1s"
                  >
                    <p>
                      19世纪，勤劳的福建茶人将茶叶由靠山背海的福建泉州港，经由海上丝绸路运往世界各地，这条承载着茶叶运往海内外的茶船古道，记载了数百年间福建茶叶贸易输出，是中国茶文化对外交流的友好桥梁，将中国茶的清醇素雅传遍八方。
                    </p>
                  </transition>
                  <transition
                    appear
                    appear-to-class="animate__animated animate__fadeInUp animate__delay-1500ms"
                  >
                    <p>
                      同时也见证了中国茶悠久的历史文化底蕴，促进了中国茶文化的传承与弘扬。
                    </p>
                  </transition>
                  <transition
                    appear
                    appear-to-class="animate__animated animate__fadeInUp animate__delay-2s"
                  >
                    <p>
                      现在我们来开始见证古代丝绸之路吧。
                    </p>
                  </transition>
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="carousel-wrap carousel-3">
                <video id="video" ref="video">
                  <source
                    src="./../../assets/shangxiahang.mp4"
                    type="video/mp4"
                  />
                </video>
                <div class="slider-wrap">
                  <div class="slider-box">
                    <el-slider
                      :show-tooltip="false"
                      v-model="vessel"
                      :step="8.3"
                      show-stops
                    >
                    </el-slider>
                  </div>
                  <div
                    class="chuan-wrap"
                    :style="{ left: 10 + 70 * chuangLeft + 'px' }"
                  >
                    <img
                      src="./../../assets/image/simulation/chuan.png"
                      alt=""
                    />
                  </div>
                  <div class="address-wrap">
                    <el-popover
                      popper-class="place-info"
                      placement="top-start"
                      title="福州"
                      width="560"
                      trigger="hover"
                    >
                      <div>
                        福州港，古称东冶港，位于中国大陆东南部，台湾海峡西岸，是大陆沿海主枢纽港之一，也是沿海主要外贸口岸及闽台贸易重要港口。其上可溯闽江沟通闽江水系，下可泛海至省内外各港和世界上许多港口。福州丰富的海洋资源以及绵长曲折的海岸线，为福州开展对外交往并成为海上丝绸之路的重要门户和发祥地创造了有利条件。
                      </div>
                      <div
                        slot="reference"
                        style="width: 69px;text-align: center;cursor:pointer"
                      >
                        福州
                      </div>
                    </el-popover>
                    <el-popover
                      popper-class="place-info"
                      placement="top-start"
                      title="泉州"
                      width="560"
                      trigger="hover"
                      content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
                    >
                      <div>
                        <p>
                          泉州，古称刺桐城，地处福建东南沿海、台湾海峡西岸，北承福州，南接厦门，东望台湾，西毗漳州、龙岩、三明，是福建三大中心城市之一。泉州历史悠久，周秦时代就已开发，公元260年（三国时期）始置东安县治，宋元时期为“东方第一大港”，被马可波罗誉为“光明之城”，是国务院首批历史文化名城、东亚文化之都、古代“海上丝绸之路”起点、全国著名侨乡、台湾汉族同胞主要祖籍地。现辖鲤城、丰泽、洛江、泉港4个区，晋江、石狮、南安3个县级市，惠安、安溪、永春、德化、金门（待统一）5个县和泉州经济技术开发区、泉州台商投资区。全市土地面积11015平方公里，2014年末常住人口844万人，少数民族有48个，以回族、畲族、苗族和蒙古族居多。方言以闽南话为主，通用语言为普通话。
                        </p>
                        <p>
                          泉州是国务院首批公布的24个历史文化名城之一，也是中国古代海上丝绸之路的起点，唐朝时为世界四大口岸之一，宋元时期被称为“东方第一大港”，被誉为
                          “世界宗教博物馆”，联合国教科文组织将全球第一个“世界多元文化展示中心”定址泉州。
                        </p>
                        <p>
                          泉州是全国著名侨乡和台湾汉族同胞主要祖籍地。分布在世界129个国家和地区的泉州籍华侨华人720万人，旅居香港同胞70万人，旅居澳门同胞6万人，三者合占全省60%以上。台湾汉族同胞中44.8%、约900万人祖籍泉州，全市现有台属近16万人，中国闽台缘博物馆落户泉州。长期以来，旅外乡亲心系桑梓，或投资办厂，或兴学育人，或捐资慈善，或兴办公益，涌现出一大批贡献巨大、成就杰出的乡贤硕彦，成为推动泉州经济社会发展的重要力量，成为泉州与世界密切联系的纽带和桥梁。
                        </p>
                        <p>
                          历史上，泉州先民充分利用当地得天独厚的宜海条件，在沿海地带长期进行造港运动，形成了“四湾”（湄州湾、泉州湾、深沪湾、围头湾）及两江（晋江、洛阳江）范围内由众多码头构成的集群港，与世界上许多国家和地区进行频繁的海上贸易活动，成为海上丝绸之路著名的东方大港。大规模的港口建设和发达的海外交通，使得古代泉州社会生产长期围绕海外贸易来进行。宋元时期，泉州的陶瓷生产遍布邑内，并出现了许多专门生产外销陶瓷的著名瓷窑，产品远销东南亚及世界各地，是海上丝绸之路通商贸易的大宗产品。海上丝绸之路的兴盛所带来的经济和文化的繁荣，又使古代泉州成为一座“市井十洲人”的国际性大都市。
                        </p>
                      </div>
                      <div
                        slot="reference"
                        style="width: 69px;text-align: center;cursor:pointer"
                      >
                        泉州
                      </div>
                    </el-popover>
                    <el-popover
                      popper-class="place-info"
                      placement="top-start"
                      title="广州"
                      width="560"
                      trigger="hover"
                      content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
                    >
                      <div>
                        <p>
                          广州古称番禺，位于南海之滨，凭借自身拥有的海上交通中心的优越条件，成为中国古代海上丝绸之路的发祥地，是世界海上交通史上惟一的2000多年长盛不衰的大港。
                        </p>
                        <p>
                          在广州南越王墓的出土文物里，有一捆来自非洲的象牙和一件来自公元前5世纪的波斯银盒。
                          秦始皇统一岭南时的番禺（今广州）已经成为了犀角、象牙、翡翠、珠玑等奇珍异宝的集散地，而秦始皇进军岭南，据说也有取得岭南这些主要来自海外的珍宝之意。
                          最早、最详细记载海上“丝绸之路”航线的是著名的《汉书?地理志》。西汉初年，汉武帝平南越后，即派使者沿着百越民间开辟的航线，从广州出发，带领船队远航南海和印度洋，经过东南亚，横越孟加拉湾，到达印度半岛的东南部，抵达锡兰（今斯里兰卡）后返航。汉武帝时期开辟的航线，标志着海上丝绸之路的发端。
                          魏晋南北朝时期，是海上丝绸之路的拓展时期。在这一时期，广州已成为计算海程的起点。通过广州来中国经商的国家和地区大为增加．有15个之多。广州成为当时商贾及朝廷命官发财致富之地，有“广州刺史但经城门一过，便得三千万钱”一说
                          。
                          历隋、唐、宋数代，广州海上丝绸之路已发展到空前繁荣的阶段。官方坚持实行开放政策，除了官方积极经营对外贸易外，又允许私人出海贸易。同时还大力鼓励外国来中国进行贸易，并在广州设立了市舶使专管外贸事务。当时中国与南洋和波斯湾地区有6条定期航线，这些航线都集中在广州，其中最著名的一条航线叫“广州通海夷道”，广州起航，越南海、印度洋、波斯湾、东非和欧州，途经100多个国家和地区，全长共14000公里．是当时世界上最长的国际航线。从此，广州成为当时闻名全世界的中国对外贸易第一大港，世界东方大港唐代大诗人刘禹锡也为珠江的“大舶参天”和“万舶争先”壮观的贸易景象所感动，而赋诗曰：“连天浪静长鲸息，映日帆多宝舶来。”
                          明清两代，由于政府实行海禁政策．其间广州成为中国海上丝绸之路惟一对外开放的贸易大港，广州海上丝绸大路贸易比唐、宋两代获得更大的发展，形成了空前的全球性大循环贸易，并且一直延续和保持到鸦片战争前夕而不衰。这一时期，从广州起航的海上丝绸之路的航线迅速增加到7条，抵达世界7大洲、160多个国家和地区。如此之多的外国商船和商品来广州进行贸易，使珠江之滨的广州呈现出一派外贸繁荣的景象。英国人威廉?希克为之惊奇，而发出了广州珠江的商船可以与伦敦泰晤士河相媲美的感叹：“珠江上船舶运行忙碌的情景，就像伦敦桥下泰晤士河，不同的是，河面的帆船形式不一，还有大帆船，在外国人眼里再没有比排列着长达几英里的帆船更为壮观的了。”
                          而且外国商人认为在广州做生意比世界任何地方都好做。正如道光十年（1830年），英国议会对在广州进行贸易的商人进行调查后得出结说：“绝大多数在广州进行贸易的商人都一致声称，广州的生意几乎比世界其他一切地方都更方便做。”
                          1949年，中华人民共和国成立之后至改革开放前的1978年，这段特殊的时期，由于众所周知的种种原因，广州很难发挥出它曾是海上丝绸之路第一大港和重要港口的历史优势，但仍然是中国首屈一指的对外贸易的重要港口。改革开放后，广州对外贸易进入一个新的发展时期，广州港成为中国第二大港。
                        </p>
                      </div>
                      <div
                        slot="reference"
                        style="width: 69px;text-align: center;cursor:pointer"
                      >
                        广州
                      </div>
                    </el-popover>
                    <el-popover
                      popper-class="place-info"
                      placement="top-start"
                      title="海口"
                      width="560"
                      trigger="hover"
                      content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
                    >
                      <div>
                        <p>
                          海南岛和雷州半岛隔海相望，海峡平均宽度不足三十公里。独特的地理位置，使海南岛成为海上丝绸之路绕不过去的一站。
                        </p>
                        <p>
                          唐宋以降，随着造船业和航海技术的发达，深海航船通过季风往来于中国南海海域。海上丝绸之路的东方起点集中在雷州半岛以东的宁波、泉州、广州等港口，海南岛的东西两岸和所辖的西沙、南沙等岛礁，自然成为这条商贸通道的重要中转站。
                          这一时期，内地的丝织品、瓷器、漆器源源不断进入海南，影响海南的制造业。随着香料的热销，海南的沉香、檀香、降真香等也成为抢手货，海南的花梨、紫檀等名贵木料都成了内陆及南洋青睐的商品；海南渔业也得到不断发展，热带海洋经济在海南岛的经济中占比也举足轻重。
                        </p>
                        <p>
                          八百年前，一艘满载货物的福建商船，从福建泉州港启航，经海上丝绸之路南下，在航行到西沙华光礁时（属海南省西沙群岛范围），不幸触礁沉没。1996年经当地渔民的偶然发现，商船得以重见天日。也是在这一时期，波斯人、阿拉伯人以及沿途穆斯林开始在海南各港口聚集或定居；海南历史上大量的带“蕃”字地名，都是海上丝绸之路的移民聚居之地。宋末以后，大陆人移民海南岛渐成规模，海南岛的开发得到了王朝的重视。值得一说的是宋末的松江人黄道婆，少年时流落到海南崖州，从黎族妇女手里学到棉纺技术，后来将这些技术带回江浙，引发这一地区纺织技术的革命，极大地刺激了华东地区丝织品的发展；这一地区生产的丝绸又返销海南，远销海上丝绸之路沿线国家。
                        </p>
                      </div>
                      <div
                        slot="reference"
                        style="width: 69px;text-align: center;cursor:pointer"
                      >
                        海口
                      </div>
                    </el-popover>
                    <el-popover
                      popper-class="place-info"
                      placement="top-start"
                      title="北海"
                      width="560"
                      trigger="hover"
                      content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
                    >
                      <div>
                        <p>
                          两千多年前，载着“黄金杂缯”的官船就从北海合浦港出发，前往东南亚直至西亚的沿海国家和城市，在古代海上丝绸之路历史上留下了辉煌篇章。
                          “自日南障塞，徐闻，合浦船行可五月，有都元国……自夫甘都卢国，船行可二月余，有黄支国……黄支之南，有已程不国。”这段记载出自班固的《汉书·地理志》。
                          要感受这句话的重大意义，我们要先理解其中涉及到的各个城市。
                          “日南”如今特指越南的中部，那里是汉朝最南的边界，“徐闻”指代今天的湛江，雷州半岛的南部，“合浦”便是今天广西北海的合浦县。同时，“都元国”则是如今印度尼西亚的加里曼丹岛，“夫甘都卢国”特指今天缅甸，“黄支国”是今天印度南部的一个古国，“已程不国”便是今天的斯里兰卡。
                          这段记载十分重要，因为它是海上丝绸之路有史以来记载的最早的一段文字，也证明了北海的合浦县是当时汉朝的海上丝绸之路的始发港之一。
                        </p>
                      </div>
                      <div
                        slot="reference"
                        style="width: 69px;text-align: center;cursor:pointer"
                      >
                        北海
                      </div>
                    </el-popover>
                    <el-popover
                      popper-class="place-info"
                      placement="top-start"
                      title="河内"
                      width="560"
                      trigger="hover"
                      content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
                    >
                      <div>
                        <p>
                          越南，位于东南亚的中南半岛东部，北面与中国的广西、云南接壤，西邻老挝、柬埔寨，国土狭长。因为靠近赤道，所以去越南的最好时节，在春、冬两季。此时气温不高、降水也较少，最适游玩。
                          越南在古时属于百越中最南端的骆越之地，骆越也是现在越南主体民族京族的祖先。西汉时，武帝灭南越国，设立合浦、南海等9个郡，其中交趾、九真、日南三郡在如今的越南境内。而海上丝绸之路也在南越平定后正式开辟。
                          《汉书·地理志》记载：自从日南郡的道路被堵塞后，船队开始由徐闻、合浦两地出发，前往东南亚各国。这条航线也就是我们所说的海上丝绸之路。
                        </p>
                      </div>
                      <div
                        slot="reference"
                        style="width: 69px;text-align: center;cursor:pointer"
                      >
                        河内
                      </div>
                    </el-popover>
                    <el-popover
                      popper-class="place-info"
                      placement="top-start"
                      title="吉隆坡"
                      width="560"
                      trigger="hover"
                      content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
                    >
                      <div>
                        <p>
                          马来西亚全称马来西亚联邦，简称大马。地处东南亚，由马来半岛南部的马来亚和位于加里曼丹岛北部的沙捞越、沙巴组成。位于太平洋和印度洋之间，全境被南中国海分成东马来西亚和西马来西亚两部分。马来西亚国土总面积约33万平方公里，其中西马13.2万平方公里，东马19.8万平方公里。马来西亚位于东南亚中心位置，扼守马六四海峡，连接海上东盟和陆上东盟，区位优势明显。
                        </p>
                      </div>
                      <div
                        slot="reference"
                        style="width: 69px;text-align: center;cursor:pointer"
                      >
                        吉隆坡
                      </div>
                    </el-popover>
                    <el-popover
                      popper-class="place-info"
                      placement="top-start"
                      title="雅加达"
                      width="560"
                      trigger="hover"
                      content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
                    >
                      <div>
                        <p>
                          雅加达有东南亚第一大城之称，从15世纪起就是沟通印度洋和太平洋的海上要冲，也曾是荷属东印度公司总部所在地，见证了西方殖民统治的兴衰。葡萄牙人、荷兰人、英国人、日本人在这里留下了有形或无形的人文印记，成为这座历史名城沧桑记忆和多元文化的一部分。
                        </p>
                        <p>
                          海上丝绸之路之雅加达，也被称作“海上香料之路”，因为这条路运输的主要大宗货物是中国产的丝绸和瓷器以及印尼产的香料。那可真是一条香飘四海、扮靓世界之路！
                        </p>
                      </div>
                      <div
                        slot="reference"
                        style="width: 69px;text-align: center;cursor:pointer"
                      >
                        雅加达
                      </div>
                    </el-popover>
                    <el-popover
                      popper-class="place-info"
                      placement="top-start"
                      title="加尔各答"
                      width="560"
                      trigger="hover"
                      content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
                    >
                      <div>
                        <p>
                          中国与孟加拉地区的交往史可以追溯到古代阿育王。但有记载的历史是在１５世纪，当时郑和下西洋与当地的穆斯林国王会谈，带来明朝皇帝的礼品，带回穆斯林国王奉献的宝石和桃子等贡品。与郑和一起来孟加拉地区的随从马欢曾对此有详细记载，对当地风土人情进行了描述。马欢说，要先到苏门答腊，然后从那里往北航行十几天，即可抵达孟加拉海岸。他看到当地人用蚕宝宝生产蚕丝纺织丝绸。印度的丝绸业是否与中国丝绸有直接联系有不同说法，有一种说法认为印度的丝绸纺织技术是从中国引进创新后自成一体。
                          连接中国与孟加拉地区的丝绸之路南线和海上丝绸之路对当地的影响可以说是方方面面，在语言、饮食、建筑、服装、农业、手工各方面都可以找到。这里的瓷器叫“齐那马迪”，意思是“中国的陶土”；泰戈尔创办的国际大学有中文系，大学的建筑模仿中国的古典建筑，有红色廊柱和亭台楼阁，柱子装饰有龙；每到春节，当地中国城的舞狮是加尔各答市民喜爱的一个重要文化节目。
                          如今，随着中印两国的经济发展和经贸交往的深入，加尔各答有望成为中印新丝绸之路的重要贸易中心。
                        </p>
                      </div>
                      <div
                        slot="reference"
                        style="width: 69px;text-align: center;cursor:pointer"
                      >
                        加尔各答
                      </div>
                    </el-popover>
                    <el-popover
                      popper-class="place-info"
                      placement="top-start"
                      title="科伦坡"
                      width="560"
                      trigger="hover"
                      content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
                    >
                      <div>
                        <p>
                          科伦坡（拉丁字母转译为：Colombo），人口642,163人，大地区为2,234,289人（2001年），位于锡兰岛西南岸、濒印度洋，北面以凯勒尼河为界。为进出斯里兰卡的门户，素有“东方十字路口”之称。是斯里兰卡的最大城市与商业中心，印度洋重要港口，世界著名的人工海港。而斯里兰卡实际的首都斯里贾亚瓦德纳普拉科特（Sri
                          jayawardenapura-kotte）却位于其郊区，但因距离过近，许多国际的官方资料仍记载科伦坡为斯里兰卡的首都，包括美国中央情报局。
                        </p>
                        <p>
                          关于科伦坡的记载，据信在两千年的罗马、阿拉伯中就已经出现。八世纪时，僧伽罗王国与外界的贸易大多由在科伦坡的穆斯林商人所经手。中国史料当中最早见于元代航海家汪大渊所著的《岛夷志略》，称之为高朗步。
                        </p>
                      </div>
                      <div
                        slot="reference"
                        style="width: 69px;text-align: center;cursor:pointer"
                      >
                        科伦坡
                      </div>
                    </el-popover>
                    <el-popover
                      popper-class="place-info"
                      placement="top-start"
                      title="内罗毕"
                      width="560"
                      trigger="hover"
                      content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
                    >
                      <div>
                        <p>
                          内罗毕（英语：Nairobi），是东非国家肯尼亚的首都，也是东非地区最大的城市，非洲最大的城市之一，一座国际化大都市。人口约350万。年平均气温17.7℃。
                        </p>
                        <p></p>
                      </div>
                      <div
                        slot="reference"
                        style="width: 69px;text-align: center;cursor:pointer"
                      >
                        内罗毕
                      </div>
                    </el-popover>
                    <el-popover
                      popper-class="place-info"
                      placement="top-start"
                      title="雅典"
                      width="560"
                      trigger="hover"
                      content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
                    >
                      <div>
                        <p>
                          雅典的名字来自于战争女神雅典娜，在公元前1000年前成为古希腊的核心城市，是欧洲哲学的发源地，诞生了亚里士多德、柏拉图、苏格拉底等一大批思想家、哲学家，被誉为“西方文明的摇篮”。雅典不但是陆上丝绸之路的重要枢纽，也是海上丝绸之路的终点之一。古希腊衰落后，雅典先后被罗马帝国、拜占庭帝国、奥斯曼帝国统治，直到19世纪，希腊才重新独立，雅典成为希腊首都。现在的雅典是世界著名旅游胜地，有着大量古希腊时期的古迹建筑，最著名的是雅典卫城、帕特农神庙、国家考古博物馆等
                        </p>
                        <p>
                          作为丝绸之路的一站，始建于公元前8世纪，是罗马帝国的发祥地。罗马城是欧洲最早形成的国际化大都市，有“永恒之城”的美誉，在罗马帝国灭亡前，罗马城一直是欧洲第一大城市，和西方文明的中心，又有“万城之城”之称。现在的罗马是意大利首都，世界天主教中心，工业、旅游业发达。漫步在今天的罗马街头，随处可见的是古罗马时期的辉煌建筑，历史的厚重感穿越千年扑面而来。
                        </p>
                      </div>
                      <div
                        slot="reference"
                        style="width: 69px;text-align: center;cursor:pointer"
                      >
                        雅典
                      </div>
                    </el-popover>
                    <el-popover
                      popper-class="place-info"
                      placement="top-start"
                      title="威斯尼"
                      width="560"
                      trigger="hover"
                      content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
                    >
                      <div>
                        <p>
                          威尼斯位于意大利东北部海岸的泻湖中心，是中世纪和早期现代世界的主要权力之城，也是东部到欧洲贸易路线发展的重要城市。它在亚得里亚海沿岸的战略位置是在拜占庭帝国和近东贸易商的范围内，这使该城市成为西部贸易中心，从东方接收海上货物并将其传播到新兴欧洲市场。
                          建立于公元5世纪，直到9世纪，威尼斯才开始成为主要的海上势力，它从拜占庭帝国授予的亚得里亚海沿岸的贸易权中获利。与此同时，该城市在9世纪变得越来越独立于帝国，发展成为一个拥有广泛海上能力的城市国家，这使得该城市能够更好地控制周围的水域，并成为一个东部到达亚得里亚海通过地中海的贸易中的积极参与者。在11世纪，军事特派团被派出用以制服威胁海上贸易的海盗，攻击从这些海盗占据的达尔马提亚海岸沿海的据点，到他们横跨海洋到东部的大本营，并且威尼斯人征服了这片海岸的大片地区。这为该地区的海上贸易带来了新的稳定性和安全性，并使威尼斯共和国成为地中海贸易领域的核心。
                        </p>
                      </div>
                      <div
                        slot="reference"
                        style="width: 69px;text-align: center;cursor:pointer"
                      >
                        威斯尼
                      </div>
                    </el-popover>
                  </div>
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="carousel-wrap carousel-4">
                <div class="carousel-view" v-if="carouselIndex === 3">
                  <transition
                    appear
                    appear-to-class="animate__animated animate__fadeInUp animate__delay-500ms"
                  >
                    <p>
                      习近平调研武夷山生态茶园：把茶文化、茶产业、茶科技这篇文章做好。
                    </p>
                  </transition>
                  <transition
                    appear
                    appear-to-class="animate__animated animate__fadeInUp animate__delay-1s"
                  >
                    <p>
                      2021年3月22日下午，正在福建考察调研的习近平总书记，来到武夷山了解当地茶产业发展情况。
                    </p>
                  </transition>
                  <transition
                    appear
                    appear-to-class="animate__animated animate__fadeInUp animate__delay-1500ms"
                  >
                    <p>
                      他指出，武夷山这个地方物华天宝，茶文化历史久远，气候适宜、茶资源优势明显，又有科技支撑，形成了生机勃勃的茶产业。要很好总结科技特派员制度经验，继续加以完善、巩固、坚持。要把茶文化、茶产业、茶科技统筹起来，过去茶产业是你们这里脱贫攻坚的支柱产业，今后要成为乡村振兴的支柱产业。
                    </p>
                  </transition>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="content-footer">
          <div
            v-if="carouselIndex === 2"
            class="submitbtn"
            style="line-height: 48px;text-align: center;margin-right: 10px"
          >
            <span @click="playVideo">播放</span>
            |
            <span @click="pauseVideo">暂停</span>
            |
            <span @click="resetVideo">重播</span>
          </div>
          <button
            v-if="carouselIndex > -6"
            @click="carouselPrev"
            class="submitbtn animate"
            style="width: 190px;height: 46px;margin-right: 10px"
          >
            <div>
              上一个
            </div>
          </button>
          <button
            v-if="carouselIndex < 3"
            @click="carouselNext"
            class="submitbtn animate"
            style="width: 190px;height: 46px;margin-right: 10px"
          >
            <div>
              下一个
            </div>
          </button>
          <button
            v-if="carouselIndex === 3"
            @click="startLearn()"
            class="submitbtn animate"
            style="width: 190px;height: 46px;"
          >
            <div>
              开始实验
            </div>
          </button>
        </div>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import HeaderCom from "../../components/headerCom";

export default {
  name: "Home",
  components: {
    HeaderCom,
  },
  data() {
    return {
      chuangLeft: 0,
      vessel: 0,
      carouselIndex: -6,
      student: {},
      navData: [
        {
          icon: "nav-icon-1.png",
          label: {
            zh: "开始实验",
            en: "start the experiment",
          },
          link: "/data/source",
        },
        {
          icon: "nav-icon-2.png",
          label: {
            zh: "系统管理",
            en: "system management",
          },
          link: "/systemmanager/system",
        },
        {
          icon: "nav-icon-3.png",
          label: {
            zh: "历史实验",
            en: "historical experiment",
          },
        },
        {
          icon: "nav-icon-4.png",
          label: {
            zh: "学习室",
            en: "study room",
          },
          link: "/studyroom",
        },
      ],
      experiment: [],
      show: false,
      DriverInstance: null,
    };
  },
  created() {
    this.loginCurrent();
    this.getRecord();
  },
  computed: {
    formatterRecord() {
      return this.experiment.filter((item) => {
        return item.status === 1;
      });
    },
  },
  watch: {
    vessel(newValue) {
      this.chuangLeft = Math.ceil(newValue / 8.3);
      let timeArray = [
        38.3,
        39.3,
        39.9,
        40.6,
        41.4,
        42,
        45,
        45,
        47.4,
        48.8,
        52.6,
        59.6,
        63,
      ];
      if (this.$refs["video"]) {
        this.$refs["video"].currentTime = timeArray[this.chuangLeft];
        this.$refs["video"].pause();
      }
    },
  },
  mounted() {
    this.stepStart();
    // setTimeout(()=>{
    //   document.querySelector('#video').addEventListener('timeupdate',(e)=>{
    //     const time = parseInt(e.currentTarget.currentTime)
    //     if(time === 38){
    //       this.vessel = 8.3
    //     }
    //     if(time === 39){
    //       this.vessel = 8.3 * 2
    //     }
    //     if(time === 40){
    //       this.vessel = 8.3 * 3
    //     }
    //     if(time === 41){
    //       this.vessel = 8.3 * 4
    //     }
    //     if(time === 42){
    //       this.vessel = 8.3 * 5
    //     }
    //     if(time === 44){
    //       this.vessel = 8.3 * 6
    //     }
    //     if(time === 45){
    //       this.vessel = 8.3 * 7
    //     }
    //     if(time === 47){
    //       this.vessel = 8.3 *8
    //     }
    //     if(time === 48){
    //       this.vessel = 8.3 *9
    //     }
    //     if(time === 52){
    //       this.vessel = 8.3 *10
    //     }
    //     if(time === 59){
    //       this.vessel = 8.3*11
    //     }
    //     if(time === 62){
    //       this.vessel = 8.3 * 12
    //     }
    //   })
    // },1000)
  },
  beforeRouteLeave(to, from, next) {
    if (this.DriverInstance) {
      this.DriverInstance.reset();
    }
    next();
  },
  methods: {
    resetVideo() {
      this.$refs["video"].currentTime = 0;
      this.$refs["video"].play();
    },
    pauseVideo() {
      this.$refs["video"].pause();
    },
    playVideo() {
      this.$refs["video"].play();
    },
    carouselPrev() {
      if (this.carouselIndex === 0) {
        return false;
      }
      this.$refs["carousel_1"].prev();
      this.carouselIndex -= 1;
      if (this.carouselIndex === 2) {
        this.$refs["video"].play();
      } else {
        this.$refs["video"].pause();
      }
    },
    carouselNext() {
      if (this.carouselIndex === 3) {
        return false;
      }
      this.$refs["carousel_1"].next();
      this.carouselIndex += 1;
      if (this.carouselIndex === 2) {
        this.$refs["video"].play();
      } else {
        this.$refs["video"].pause();
      }
    },
    stepStart() {
      if (!localStorage.getItem("HomeOrigin")) {
        setTimeout(() => {
          this.show = true;
        }, 1000);
      }
      if (
        localStorage.getItem("HomeOrigin") &&
        localStorage.getItem("StudyRoom") &&
        !localStorage.getItem("HomeStart")
      ) {
        this.DriverInstance = this.Driver("HomeStart");
        setTimeout(() => {
          this.DriverInstance.start();
        }, 1500);
      }
    },
    startLearn() {
      this.show = false;
      localStorage.setItem("HomeOrigin", "HomeOrigin");
      this.DriverInstance = this.Driver("HomeOrigin");
      this.DriverInstance.start();
    },
    isBlur(type) {
      switch (type) {
        case true:
          document.querySelector("#app").classList.add("blur");
          break;
        case false:
          document.querySelector("#app").classList.remove("blur");
          break;
      }
    },
    loginCurrent() {
      this.$axios.get("/login/current").then((res) => {
        if (res.succeed) {
          this.student = res.student;
        }
      });
    },
    getRecord() {
      this.$axios
        .post("/student/experiment/list", {
          experiment: { status: 1 },
          orderAsc: "desc",
          orderProperty: "te.create_time",
        })
        .then((res) => {
          if (res.succeed) {
            this.experiment = res.items;
          }
        });
    },
    learn() {
      this.$router.push({
        path: "/studyroom",
        query: Object.assign(this.$route.query, {}),
      });
    },
    start() {
      this.$axios.post("/student/experiment/create", {}).then((res) => {
        if (res.succeed) {
          localStorage.removeItem("source");
          localStorage.removeItem("generate");
          localStorage.removeItem("comparison");
          localStorage.removeItem("putaway");
          let _query = this.$route.query;
          this.$router.push({
            path: "/data/source",
            query: Object.assign(_query, { id: res.experiment.id }),
          });
        }
      });
    },
  },
};
</script>
<style>
.custom-modal .el-dialog {
  margin: 0 auto 0;
}

.custom-modal .el-dialog__header {
  display: none;
}

.custom-modal .el-dialog__body {
  padding: 0;
}
.place-info .el-popover__title {
  font-size: 30px;
  font-weight: bolder;
}
</style>
<style scoped lang="scss">
.carousel-1-1 {
  height: 100%;
  background: url("./../../assets/image/simulation/tea7.jpg") center center
    no-repeat;
  background-size: cover;
}
.carousel-1-2 {
  height: 100%;
  background: url("./../../assets/image/simulation/tea6.jpg") center center
    no-repeat;
  background-size: cover;
}
.carousel-1-3 {
  height: 100%;
  background: url("./../../assets/image/simulation/tea8.png") center center
    no-repeat;
  background-size: cover;
}
.carousel-1-4 {
  height: 100%;
  background: url("./../../assets/image/simulation/tea9.jpg") center center
    no-repeat;
  background-size: cover;
}
.carousel-1-5 {
  height: 100%;
  background: url("./../../assets/image/simulation/tea10.jpg") center center
    no-repeat;
  background-size: cover;
}
.carousel-1-6 {
  height: 100%;
  background: url("./../../assets/image/simulation/tea11.png") center center
    no-repeat;
  background-size: cover;
}
.carousel-1 {
  height: 100%;
  background: url("./../../assets/image/simulation/tea2.png") center center
    no-repeat;
  background-size: cover;
}

.carousel-2 {
  height: 100%;
  background: url("./../../assets/image/simulation/tea5.png") center center
    no-repeat;
  background-size: cover;
}

.carousel-3 {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  video {
    width: 100%;
  }

  .video-btn {
    position: absolute;
    right: 20px;
    bottom: 110px;
    opacity: 0.5;
    font-size: 20px;
    border: 1px solid #2196f3;
    border-radius: 10px;
    padding: 10px;

    .video-btn-item {
      padding: 4px;
      font-size: 20px;
    }

    &:hover {
      transition: all 0.3s linear;
      opacity: 1;
      background: #ffffff;
    }
  }

  .slider-wrap {
    position: absolute;
    left: 10px;
    bottom: 10px;
    z-index: 1000;
    background: #ffffff;
    width: 920px;
    height: 100px;
    border-radius: 10px;
    opacity: 0.3;
    transition: opacity 1s linear;
    &:hover {
      opacity: 1;
      transition: opacity 1s linear;
    }

    .slider-box {
      width: 828px;
      position: absolute;
      left: 40px;
      bottom: 20px;
    }

    .chuan-wrap {
      position: absolute;
      bottom: 50px;
      left: 10px;
      animation: chuanMove 6s ease-in-out infinite;
      transition: left 0.6s ease-in-out;

      > img {
        width: 60px;
        transform: rotateY(190deg);
      }
    }

    .address-wrap {
      width: 100%;
      position: absolute;
      bottom: 10px;
      left: 4px;
      display: flex;

      > div {
        width: 69px;
        text-align: left;
      }
    }
  }
}

.carousel-4 {
  height: 100%;
  background: url("./../../assets/image/simulation/tea4.png") center center
    no-repeat;
  background-size: cover;
}

.carousel-view {
  backdrop-filter: blur(20px);
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  padding: 0 60px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;

  p {
    font-size: 30px;
  }
}

.left-enter-active {
  transition: opacity 0.5s;
}

.left-enter,
.left-leave-to {
  opacity: 0;
}

.name-wrap {
  text-align: center;
  margin-bottom: 42px;

  h3 {
    font-size: 36px;
    font-weight: bold;
    line-height: 46px;
    color: #005be7;
    opacity: 1;
    margin-bottom: 4px;
  }

  h6 {
    font-size: 16px;
    font-weight: 400;
    color: #005be7;
    opacity: 1;
    text-transform: capitalize;
  }
}

.nav-item {
  cursor: pointer;
  height: 300px;
  background: #ffffff;
  opacity: 1;
  border-radius: 8px;
  text-align: center;
  padding-top: 62px;
  margin-bottom: 24px;
  box-shadow: 0 0 2px #c6c6c6;

  &:hover {
    transition: box-shadow 0.3s linear;
    box-shadow: 0 0 10px #cacaca;
  }

  .icon {
    margin-bottom: 12px;

    img {
      width: 112px;
    }
  }

  .label {
    h3 {
      font-size: 30px;
      font-weight: bold;
      line-height: 38px;
      color: #31394d;
      opacity: 1;
      margin-bottom: 4px;
    }

    p {
      font-size: 10px;
      font-weight: 400;
      line-height: 13px;
      color: #748aa1;
      opacity: 1;
      text-transform: capitalize;
    }
  }
}

.history {
  height: 404px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  opacity: 1;
  border-radius: 15px;
  padding: 30px;

  .title {
    margin-bottom: 30px;

    h3 {
      font-size: 26px;
      font-weight: bold;
      line-height: 33px;
      color: #454b60;
      opacity: 1;
    }

    p {
      font-size: 12px;
      font-weight: 400;
      color: #999999;
      opacity: 1;
    }
  }

  .content {
    .item {
      height: 80px;
      background: #f5f6fa;
      opacity: 1;
      border-radius: 12px;
      padding: 20px;
      display: flex;
      margin-bottom: 14px;

      .cell {
        display: flex;
        align-items: center;
        margin-right: 100px;

        &:last-child {
          margin-right: 0;
        }

        span.txt {
          margin-left: 14px;
          font-size: 18px;
          font-weight: 400;
          color: #748aa1;
        }

        &.right {
          flex-grow: 1;
        }

        button {
          width: 134px;
          height: 54px;
          background: linear-gradient(
            90deg,
            rgba(119, 166, 239, 0.97) 0%,
            #005be7 100%
          );
          box-shadow: 0px 1px 4px rgba(119, 166, 239, 0.97);
          opacity: 1;
          border-radius: 60px;
          font-size: 18px;
          font-family: Microsoft YaHei UI;
          font-weight: 400;
          color: white;
        }
      }
    }
  }
}

.user-wrap {
  padding: 20px 30px;
  height: 734px;
  background: #ffffff;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.16);
  opacity: 1;
  border-radius: 15px;

  .title {
    margin-bottom: 30px;

    h3 {
      font-size: 26px;
      font-weight: bold;
      line-height: 33px;
      color: #454b60;
    }

    p {
      font-size: 12px;
      font-weight: 400;
      color: #999999;
    }
  }

  .content {
    .item {
      height: 98px;
      border: 1px solid #f1f1f1;
      opacity: 1;
      border-radius: 12px;
      padding: 20px;
      margin-bottom: 20px;

      .icon {
        float: left;
        margin-right: 30px;
      }

      .txt {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;

        p:first-child {
          font-size: 14px;
          font-weight: 400;
          line-height: 17px;
          color: #999999;
          margin-bottom: 6px;
        }

        p:last-child {
          font-size: 18px;
          font-weight: bold;
          line-height: 23px;
          color: #666666;
        }
      }
    }
  }
}

.custom-modal {
  .content {
    overflow: hidden;
    position: relative;

    .content-title {
      position: absolute;
      left: 10px;
      top: 10px;
      z-index: 9999;
      background: #ffffff;
      border-radius: 10px;
      padding: 10px;
      font-size: 18px;
      font-weight: bolder;

      .text {
        height: 33px;
        font-size: 26px;
        font-family: Microsoft YaHei UI, serif;
        font-weight: bold;
        line-height: 33px;
        color: #454b60;
        position: relative;
      }
    }

    .content-main {
      p {
        text-indent: 54px;
        font-size: 28px;
        line-height: 44px;
        margin-bottom: 10px;
        font-family: cursive, sans-serif;
      }

      .guide {
        text-align: center;
        padding: 10px;

        img {
          width: 800px;
          max-width: 100%;
        }
      }
    }

    .content-footer {
      position: absolute;
      right: 0;
      margin: auto;
      bottom: 10px;
      z-index: 999;
      opacity: 0.6;
      transition: opacity 0.3s linear;
      display: flex;
      justify-content: flex-end;
      padding: 10px;

      &:hover {
        transition: opacity 0.3s linear;
        opacity: 1;
      }

      .submitbtn {
        span {
          cursor: pointer;

          &:hover {
            color: #ff5722;
          }
        }
      }
    }
  }

  @keyframes chuanMove {
    0% {
      transform: rotateZ(0deg);
    }
    33% {
      transform: rotateZ(4deg);
    }
    69% {
      transform: rotateZ(-4deg);
    }
    100% {
      transform: rotateZ(0deg);
    }
  }
}
</style>
